var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextRecognition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.75C3.41421 15.75 3.75 16.0858 3.75 16.5V19.5C3.75 19.9142 4.08578 20.25 4.5 20.25H7.5C7.91421 20.25 8.25 20.5858 8.25 21C8.25 21.4142 7.91421 21.75 7.5 21.75H4.5C3.25737 21.75 2.25 20.7427 2.25 19.5V16.5C2.25 16.0858 2.58579 15.75 3 15.75Z",
    fill: "#EE7200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 15.75C21.4142 15.75 21.75 16.0858 21.75 16.5V19.5C21.75 20.7427 20.7427 21.75 19.5 21.75H16.5C16.0858 21.75 15.75 21.4142 15.75 21C15.75 20.5858 16.0858 20.25 16.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V16.5C20.25 16.0858 20.5858 15.75 21 15.75Z",
    fill: "#EE7200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 3C15.75 2.58579 16.0858 2.25 16.5 2.25H19.5C20.7427 2.25 21.75 3.25737 21.75 4.5V7.5C21.75 7.91421 21.4142 8.25 21 8.25C20.5858 8.25 20.25 7.91421 20.25 7.5V4.5C20.25 4.08578 19.9142 3.75 19.5 3.75H16.5C16.0858 3.75 15.75 3.41421 15.75 3Z",
    fill: "#EE7200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5V7.5C3.75 7.91421 3.41421 8.25 3 8.25C2.58579 8.25 2.25 7.91421 2.25 7.5V4.5C2.25 3.25736 3.25736 2.25 4.5 2.25H7.5C7.91421 2.25 8.25 2.58579 8.25 3C8.25 3.41421 7.91421 3.75 7.5 3.75H4.5Z",
    fill: "#EE7200"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V17.5C12.75 17.9142 12.4142 18.25 12 18.25C11.5858 18.25 11.25 17.9142 11.25 17.5V7.5C11.25 7.08579 11.5858 6.75 12 6.75Z",
    fill: "#EE7200"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 7.5C7.75 7.08579 8.08579 6.75 8.5 6.75H15.5C15.9142 6.75 16.25 7.08579 16.25 7.5C16.25 7.91421 15.9142 8.25 15.5 8.25H8.5C8.08579 8.25 7.75 7.91421 7.75 7.5Z",
    fill: "#EE7200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextRecognition);
export default __webpack_public_path__ + "static/media/text-recognition.157060c0.svg";
export { ForwardRef as ReactComponent };